export const modal = ()=>{
    
    //MODAL MENÚ HAMBURGUESA
    var openModalMenu = document.querySelector('#openModalMenu');
    var closeModalMenu = document.querySelector('#closeModalMenu');
    var modalMenu = document.querySelector('#modalMenu');

    if (openModalMenu && closeModalMenu && modalMenu) {
        openModalMenu.addEventListener('click', () => {
            modalMenu.classList.add('activeModalMenu');
        })
        closeModalMenu.addEventListener('click', () => {
            modalMenu.classList.remove('activeModalMenu');
        })
    }

    //MODAL SWIPER
    // var closeModalSwiper = document.querySelectorAll('.closeModalSwiper');
    // var modalSwiper = document.querySelector('.swiperContainer');

    // closeModalSwiper.forEach( function(valor) {
    //     valor.addEventListener("click", function() {

    //         //Tremos la url anterior
    //         var prevUrl = document.referrer;
    //         var prevUrlString = prevUrl.indexOf("regiones");

    //         //Validamos que la url anterior tenga la palabra "regiones"
    //         if(prevUrlString != -1) {
    //             location.href = prevUrl;
    //         } else {
    //             modalSwiper.classList.add('inactive');
    //         }
    //     });
    // });

    //MODAL CONEXIÓN
    var modalConnection = document.querySelector('#modalConnection');
    var closeModalConnection = document.querySelector('#closeModalConnection');
    var contentInstrucciones = document.querySelector('#contentInstrucciones');

    

    if (modalConnection) {
        function loadTimeout(){
        }
        setTimeout(function() {
            // modalConnection.style.display = "flex";
            // contentInstrucciones.style.display = "none";            
        },5000);
    
        closeModalConnection.addEventListener('click', function() {
            modalConnection.style.display = "none";
            contentInstrucciones.style.display = "flex";
        });
    }
}